export default __webpack_public_path__ + "static/2-b0a863606725dedc308111d277ec8380.jpg";